import type { CrmIntegrationProvider } from "app/pages/sales-intelligence/domain/crm-integration/types/provider";

import { MANAGEMENT_ROUTE, SI_MANAGEMENT_ROOT_URL } from "./routes";

//ROUTES
export const MANAGEMENT_CRM_ROUTE = `${MANAGEMENT_ROUTE}-crm`;
export const MANAGEMENT_CRM_INTEGRATIONS_ROUTE = `${MANAGEMENT_CRM_ROUTE}-integrations`;
export const MANAGEMENT_APIS_AND_WEBHOOKS_ROUTE = `${MANAGEMENT_ROUTE}-apis-and-webhooks`;
export const MANAGEMENT_GATEWAY = `${MANAGEMENT_ROUTE}-gateway/:featureName`;
export const MANAGEMENT_MCP = `${MANAGEMENT_ROUTE}-mcp`;

export const SF_MANAGEMENT_MANAGE_ROUTE = `${MANAGEMENT_ROUTE}-salesforce`;
export const SF_MANAGEMENT_ROOT_ROUTE_EXPORT = `${SF_MANAGEMENT_MANAGE_ROUTE}-export`;
export const SF_MANAGEMENT_ROOT_ENRICHMENT_ROUTE = `${SF_MANAGEMENT_MANAGE_ROUTE}-enrichment`;
export const SF_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE = `${SF_MANAGEMENT_MANAGE_ROUTE}-enrichment/:id`;
export const SF_MANAGEMENT_ENRICHMENT_LOGS_ROUTE = `${SF_MANAGEMENT_MANAGE_ROUTE}-enrichment-logs`;

export const HS_MANAGEMENT_MANAGE_ROUTE = `${MANAGEMENT_ROUTE}-hubspot`;
export const HS_MANAGEMENT_ROOT_ROUTE_EXPORT = `${HS_MANAGEMENT_MANAGE_ROUTE}-export`;
export const HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE = `${HS_MANAGEMENT_MANAGE_ROUTE}-enrichment`;
export const HS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE = `${HS_MANAGEMENT_MANAGE_ROUTE}-enrichment/:id`;
export const HS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE = `${HS_MANAGEMENT_MANAGE_ROUTE}-enrichment-logs`;

export const DYNAMICS_MANAGEMENT_MANAGE_ROUTE = `${MANAGEMENT_ROUTE}-dynamics`;
export const DYNAMICS_MANAGEMENT_ROOT_ROUTE_EXPORT = `${DYNAMICS_MANAGEMENT_MANAGE_ROUTE}-export`;
const DYNAMICS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE = `${DYNAMICS_MANAGEMENT_MANAGE_ROUTE}-enrichment`;
const DYNAMICS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE = `${DYNAMICS_MANAGEMENT_MANAGE_ROUTE}-enrichment/:id`;
const DYNAMICS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE = `${DYNAMICS_MANAGEMENT_MANAGE_ROUTE}-enrichment-logs`;

export const MANAGEMENT_SIGNALS_API_ROUTE = `${MANAGEMENT_ROUTE}-signals-api`;
export const MANAGEMENT_SIGNALS_REST_API_ROUTE = `${MANAGEMENT_ROUTE}-signals-rest-api`;
export const MANAGEMENT_SAVED_SEARCH_WEBHOOKS_ROUTE = `${MANAGEMENT_ROUTE}-saved-search-webhooks`;
export const EXTENSION_MANAGEMENT_MANAGE_ROUTE = `${MANAGEMENT_ROUTE}-extension`;
export const TEAMS_MANAGEMENT_ROUTE = `${MANAGEMENT_ROUTE}-teams`;
export const TEAM_DETAIL_ROUTE = `${TEAMS_MANAGEMENT_ROUTE}-detail`;
export const PLAYBOOKS_ROUTE = `${MANAGEMENT_ROUTE}-playbooks`;
export const PLAYBOOK_CREATE_ROUTE = `${PLAYBOOKS_ROUTE}-create`;
export const PLAYBOOK_EDIT_ROUTE = `${PLAYBOOKS_ROUTE}-edit`;

export const SUPPRESSION_LIST_ABSTRACT_ROUTE = `${MANAGEMENT_ROUTE}-suppressionList`;

export const SL_ROUTES = {
    upload: `${SUPPRESSION_LIST_ABSTRACT_ROUTE}-upload`,
};

//URLS
export const MANAGEMENT_CRM_URL = `${SI_MANAGEMENT_ROOT_URL}/crm`;
export const MANAGEMENT_CRM_INTEGRATIONS_URL = `${MANAGEMENT_CRM_URL}/integrations`;
export const MANAGEMENT_APIS_AND_WEBHOOKS_URL = `${SI_MANAGEMENT_ROOT_URL}/api-webhooks`;

export const MANAGEMENT_GATEWAY_URL = `${SI_MANAGEMENT_ROOT_URL}/gateway/:featureName`;

export const MANAGEMENT_MCP_URL = `${SI_MANAGEMENT_ROOT_URL}/mcp`;
export const SF_MANAGEMENT_ROOT_URL = `${SI_MANAGEMENT_ROOT_URL}/salesforce`;
export const MANAGEMENT_ROOT_URL = `${SI_MANAGEMENT_ROOT_URL}/management`;
export const HS_MANAGEMENT_MANAGE_URL = `${SI_MANAGEMENT_ROOT_URL}/hubspot`;
export const DYNAMICS_MANAGEMENT_MANAGE_URL = `${SI_MANAGEMENT_ROOT_URL}/dynamics`;
export const EXTENSION_MANAGEMENT_MANAGE_URL = `${SI_MANAGEMENT_ROOT_URL}/extension`;
export const TEAMS_MANAGEMENT_URL = `${SI_MANAGEMENT_ROOT_URL}/teams`;
export const TEAM_DETAIL_URL = `${TEAMS_MANAGEMENT_URL}/:id`;
export const PLAYBOOKS_URL = `${SI_MANAGEMENT_ROOT_URL}/playbooks`;
export const PLAYBOOK_CREATE_URL = `${SI_MANAGEMENT_ROOT_URL}/playbooks/new?shared`;
export const PLAYBOOK_EDIT_URL = `${SI_MANAGEMENT_ROOT_URL}/playbooks/:id/edit`;
export const SAVED_SEARCH_WEBHOOKS_MANAGEMENT_URL = `${SI_MANAGEMENT_ROOT_URL}/saved-search-webhooks`;
export const MANAGEMENT_SIGNALS_API_URL = `${SI_MANAGEMENT_ROOT_URL}/signals-webhook`;
export const MANAGEMENT_SIGNALS_REST_API_URL = `${SI_MANAGEMENT_ROOT_URL}/signals-rest-api`;

export const MANAGE_INTEGRATION_ROUTE: Record<CrmIntegrationProvider, string> = {
    hubspot: HS_MANAGEMENT_MANAGE_ROUTE,
    salesforce: SF_MANAGEMENT_MANAGE_ROUTE,
    dynamics: DYNAMICS_MANAGEMENT_MANAGE_ROUTE,
};

export const MANAGE_CRM_ENRICHMENT_ROUTE = {
    hubspot: HS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    salesforce: SF_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
    dynamics: DYNAMICS_MANAGEMENT_ROOT_ENRICHMENT_ROUTE,
};

export const CRM_ENRICHMENT_JOB_EDIT_ROUTE = {
    hubspot: HS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE,
    salesforce: SF_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE,
    dynamics: DYNAMICS_MANAGEMENT_JOB_ENRICHMENT_EDIT_ROUTE,
};

export const CRM_ENRICHMENT_LOGS_ROUTE = {
    hubspot: HS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE,
    salesforce: SF_MANAGEMENT_ENRICHMENT_LOGS_ROUTE,
    dynamics: DYNAMICS_MANAGEMENT_ENRICHMENT_LOGS_ROUTE,
};

export const EXPORT_INTEGRATION_ROUTE = {
    hubspot: HS_MANAGEMENT_ROOT_ROUTE_EXPORT,
    salesforce: SF_MANAGEMENT_ROOT_ROUTE_EXPORT,
    dynamics: DYNAMICS_MANAGEMENT_ROOT_ROUTE_EXPORT,
};
